export const cancelamentoConstants = {
  CANCELAMENTO_REQUEST: 'CANCELAMENTO_REQUEST',
  CANCELAMENTO_SUCCESS: 'CANCELAMENTO_SUCCESS',
  CANCELAMENTO_FAILURE: 'CANCELAMENTO_FAILURE',
};
